import React from 'react';

import { Box, Grid, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import ProductAvailabilityFormDialog from './form/product_availability_form_dialog';
import DeleteProductAvailabilityFormDialog from './form/delete_product_availability_form_dialog';
import FilterPaper from "../../../../common/filter_paper";

const CalendarFilters = ({ from, onChangeTimeFrom, to, onChangeTimeTo, refreshCalendar }) => (
    <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>

        <Box sx={ { display: 'flex', justifyContent: 'flex-end' } }>
            <Stack direction="row" spacing={ 2 }>
                <ProductAvailabilityFormDialog refreshCalendar={ refreshCalendar }/>
                <DeleteProductAvailabilityFormDialog refreshCalendar={ refreshCalendar }/>
            </Stack>
        </Box>

        <FilterPaper title="Zakres widoku kalendarza">
            <Grid container spacing={ 3 }>
                <Grid item xs={ 12 } sm={ 6 } md={ 3 }>
                    <DatePicker
                        displayWeekNumber
                        value={ from }
                        label="Data od"
                        onChange={ newDate => onChangeTimeFrom(newDate) }
                        slotProps={ { textField: { size: 'small', fullWidth: true } } }
                    />
                </Grid>
                <Grid item xs={ 12 } sm={ 6 } md={ 3 }>
                    <DatePicker
                        displayWeekNumber
                        value={ to }
                        label="Data do"
                        onChange={ newDate => onChangeTimeTo(newDate) }
                        slotProps={ { textField: { size: 'small', fullWidth: true } } }
                    />
                </Grid>
            </Grid>
        </FilterPaper>

    </Box>
);

export default CalendarFilters;